import React from 'react';
import ProdutosTodos  from '../components/Products';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Products = () => {
  
  return (
    <div className="content-wrapper">
      <h3>Produto(s)</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Produto(s)</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <ProdutosTodos />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <ProdutosTodos />
        </Col>
      </Row>
    </div>
  );
};

export default Products;
